<div class="view-dialog-container">
  <div class="header-container">
    <div class="header-title">
      WELCOME TO THE CONSTRUCTION PATHWAYS EXPERIENCE PORTAL
    </div>
    <div class="cros-icon" (click)="close()">&#x2715;</div>
  </div>

  <div class="body-container">
    <p class="body-pera">
      This portal helps you track student participation in CSQ Construction
      Pathways Events and other construction-related activities and <br />
      experiences. Making it easier to connect students with future career
      opportunities
    </p>

    <div class="grid-container-items">
      <!-- Card 1: Support student career pathways (Green) -->
      <div class="grid-items card-green">
        <div class="card-image-conatiner">
          <img
            class="card-icon"
            src="../../../../../assets/images/Trex_1.svg"
          />
        </div>
        <h3>Support student career pathways</h3>
        <p>
          Record Construction Pathways event attendance and log
          construction-related work experience and activities in one place.
        </p>
      </div>

      <!-- Card 2: Strengthen student CVs (Yellow) -->
      <div class="grid-items card-yellow">
        <div class="card-image-conatiner">
          <img
            class="card-icon"
            src="../../../../../assets/images/Trex_2.svg"
          />
        </div>
        <h3>Strengthen student CVs</h3>
        <p>
          Build a learning passport that showcases industry exposure, skills,
          and experience.
        </p>
      </div>

      <!-- Card 3: Showcase emerging talent (Orange) -->
      <div class="grid-items card-orange">
        <div class="card-image-conatiner">
          <img
            class="card-icon"
            src="../../../../../assets/images/Trex_4.svg"
          />
        </div>
        <h3>Showcase emerging talent</h3>
        <p>
          Identify and highlight engaged students for future industry
          connections.
        </p>
      </div>

      <!-- Card 4: Access Construction Pathways learning resources (Blue) -->
      <div class="grid-items card-blue">
        <div class="card-image-conatiner">
          <img
            class="card-icon"
            src="../../../../../assets/images/Trex_3.svg"
          />
        </div>
        <h3>Access Construction Pathways learning resources</h3>
        <p>All available directly through the portal.</p>
      </div>
    </div>

    <p class="body-pera body-pera-bold">
      By using the portal to log student experiences, you're helping them build
      a strong industry profile, keeping all their construction related
      engagement and achievements in one place to better prepare them for future
      opportunities
    </p>

    <div class="video-container">
      <div class="video-link">
        <button (click)="onPlayVideo()" class="watch-button">
          Watch Video
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="10"
              cy="10"
              r="9"
              stroke="currentColor"
              stroke-width="1.5"
              fill="none"
            />
            <path d="M8 7 L14 10 L8 13 Z" fill="currentColor" />
          </svg>
        </button>
      </div>

      <button (click)="close()" class="get-started-button">GET STARTED</button>
    </div>

    <div class="check-box-container">
      <div class="checkInput">
        <div *ngIf="dontShowAgain" class="checkInput-active">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7.25" fill="#ffffff" stroke="#ffffff" stroke-width="1.5" />
            <path d="M4.75 8.25 L7 10.5 L11.5 5.75" stroke="#007BFF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" fill="none" />
          </svg>
        </div>
        <div *ngIf="!dontShowAgain" class="checkInput-inactive">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7.25" stroke="#ffffff" stroke-width="1.5" fill="none" />
          </svg>
        </div>
        <input
          type="checkbox"
          id="dontShowAgain"
          [(ngModel)]="dontShowAgain"
          (ngModelChange)="onCheckboxChange($event)"
        />
      </div>
      <label for="dontShowAgain">Don't show this again</label>
    </div>
  </div>
</div>
